import { Box, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { useState, useEffect } from 'react'
import LineChartView from '../../../ChartDashboard/CommonCharts/LineChartView'
import TriggerApiOnView from './TriggerApiOnView';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Line } from 'react-chartjs-2';
import ExpandPopUp from '../../../ChartDashboard/CommonCharts/ExpandPopUp';
import { Growth_chart } from '../../../../Utility/Constants';
import AntenatalChart from '../../DoctorOBGYN/Charts/AntenatalChart';
import { getStandardGrowthCurves } from '../../../../Utility/GrowthChartReferenceData'

const chart = {
    hba1cChart: [],
    glucoseChart: [],
}
const PD_grow = {
    labels: [],
    datasets: []
}
export default function CollabCharts(props) {
    const { id, isProgrammaticScroll, userData, details, roleType, doctorID } = props;

    const [chartData, setchartData] = useState(chart);
    const [listOfLabels, setlistOfLabels] = useState([]);
    const [listOfValues, setlistOfValues] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [PatientID, setPatientID] = useState('');
    const [isExpandCliked, setisExpandCliked] = useState(false);
    const [title, settitle] = useState('');
    const [immunizationData, setimmunizationData] = useState([]);
    const [filterItem, setfilterItem] = useState(Growth_chart);
    const [filter_data, setfilter_data] = useState('height');
    const [growthChart, setgrowthChart] = useState([]);
    const [ageGroup, setAgeGroup] = useState(null);
    const [PD_data, setPD_data] = useState(PD_grow);
    const [FollicularPhase, setFollicularPhase] = useState('');
    const [OvulatoryPhase, setOvulatoryPhase] = useState('');
    const [LutealPhase, setLutealPhase] = useState('');
    const [Comments, setComments] = useState('');
    const [SelectedOvulation, setSelectedOvulation] = useState({});
    const [PrevOvulaData, setPrevOvulaData] = useState([]);
    const [OvulationHeader, setOvulationHeader] = useState({});
    const [OvulationTable, setOvulationTable] = useState([]);
    const [state, setState] = useState({
        patientDetails: {},
        growthTooltipData: [],
        chartYMin: null,
        chartYMax: null,
    })

    useEffect(() => {
        try {
            const cachedData = getCachevalue('DoctorPatientData');
            const appointData = JSON.parse(cachedData);
            if (appointData?.patient_id) {
                setState((prev) => ({...prev, patientDetails:appointData }));
                setPatientID(appointData.patient_id || '');
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }, []);

    useEffect(() => {
        if (OvulationTable && OvulationTable.length > 0) {
            setOvulationTable(OvulationTable)
        }
    }, [OvulationTable]);

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }
    const errorMessage = (msg) => {
        seterrorMsg(true)
        seterrorMsgText(msg)
    }
    const getH1bacData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_CHART_HBA1C + `?patient_id=${PatientID}&doc_id=${doctorID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.data
                        let listOfLabels = [];
                        let listOfValues = [];
                        data.forEach(item => {
                            let chart_date = "";
                            chart_date = item.chart_date ? formatDate(item.chart_date) : item.chart_date;
                            listOfLabels.push(chart_date);
                            listOfValues.push(item.chart_value);
                        })
                        setchartData((prevData) => ({
                            ...prevData,
                            hba1cChart: data || [],
                        }));
                        setlistOfLabels(listOfLabels || [])
                        setlistOfValues(listOfValues || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getGlucouseData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_GLUCOUSE_LOG + `?patient_id=${PatientID}&doc_id=${doctorID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setchartData((prevData) => ({
                            ...prevData,
                            glucoseChart: response.data.data || [],
                        }));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getImmunizationData = () => {
        try {
            RestAPIService.getAll(Serviceurls.PD_IMMUNIZATION_CHART + `?patient_id=${PatientID}&doc_id=${doctorID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response.data.data
                        const grouped = {};
                        data.forEach(({ age, ...rest }) => {
                            if (!grouped[age]) {
                                grouped[age] = { age, data: [] };
                            }
                            grouped[age].data.push(rest);
                        });
                        setimmunizationData(Object.values(grouped))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const PrevOvulationData = () => {
        try {
            RestAPIService.getAll(Serviceurls.OVULATION_INDUCTION_LIST + `?patient_id=${PatientID}`).
                then((response) => {
                    if (response.data.status === "success") {
                        setPrevOvulaData(response.data.data)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }

    const GetOvulationData = (InductID = null) => {
        try {
            let APIUrl = ""
            if (InductID) {
                APIUrl = Serviceurls.OVULATION_INDUCTION_DATA_GET + `?patient_id=${PatientID}&ovulation_induction_id=${InductID}&doc_id=${doctorID}`
            } else {
                APIUrl = Serviceurls.OVULATION_INDUCTION_DATA_GET + `?patient_id=${PatientID}&doc_id=${doctorID}`
            }
            RestAPIService.getAll(APIUrl).
                then((response) => {
                    if (response.data.status === "success") {
                        setOvulationHeader(response.data.data?.ovulation_induction_header || {})
                        setOvulationTable(response.data.data?.ovulation_induction_values || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }

    const getchartData = (section) => {
        switch (section) {
            case "hba1ccharts":
                getH1bacData()
                break;
            case "glugosecharts":
                getGlucouseData()
                break;
            case "immunization":
                getImmunizationData()
                break;
            case "growth":
                if(PatientID){
                    getGrowthchart()
                }
                break;
            case "ovulation":
                GetOvulationData()
                PrevOvulationData()
                break;
            default:
                break;
        }

    }

    let grapharray = []
    chartData.glucoseChart.map((item) => {
        let fasting = item.fasting ? item.fasting : 0
        let postBreakfast = item.number_2_hrs_post_bfast ? item.number_2_hrs_post_bfast : 0
        let postglucose = item.number_2_post_glucose ? item.number_2_post_glucose : 0
        let Lunch = item.lunch ? item.lunch : 0
        let PostLunch = item.number_2_hrs_post_lunch ? item.number_2_hrs_post_lunch : 0
        let Pre_Dinner = item.pre_dinner ? item.pre_dinner : 0
        let Dinner = item.number_2_hrs_post_dinner ? item.number_2_hrs_post_dinner : 0
        grapharray.push(fasting, postBreakfast, Lunch, PostLunch, Pre_Dinner, Dinner, postglucose)
    })
    grapharray = grapharray.map(Number)

    let minVal = Math.min(...grapharray);
    let MaxVal = Math.max(...grapharray);

    const options = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            title: {
                display: true,
                text: 'BLOOD GLUCOSE LEVEL',
            },
        },
        scales: {
            y: {
                display: true,
                position: 'left',
                min: minVal,
                max: MaxVal,

            },
            y1: {
                type: 'linear',
                display: false,
                position: 'right',
                min: minVal,
                max: MaxVal,

                grid: {
                    drawOnChartArea: false,
                },
            },
            y2: {
                type: 'linear',
                display: false,
                position: 'left',
                min: minVal,
                max: MaxVal,

                grid: {
                    drawOnChartArea: false,
                },
            },
            y3: {
                type: 'linear',
                display: false,
                position: 'right',
                min: minVal,
                max: MaxVal,

                grid: {
                    drawOnChartArea: false,
                },
            },
            y4: {
                type: 'linear',
                display: false,
                position: 'left',
                min: minVal,
                max: MaxVal,

                grid: {
                    drawOnChartArea: false,
                },
            },
            y5: {
                type: 'linear',
                display: false,
                position: 'right',
                min: minVal,
                max: MaxVal,

                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };
    let glucoseLabel = chartData.glucoseChart.map((item) => item.activity_date ? item.activity_date.split("-").reverse().join("-") : 0)

    const data = {
        labels: glucoseLabel,
        datasets: [
            {
                label: "Fasting",
                data: chartData.glucoseChart.map((item) => item.fasting ? item.fasting : 0),
                borderColor: '#1E972A',
                backgroundColor: '#1E972A',
                yAxisID: 'y',
            },
            {
                label: "2 Hours Post Glucose Blood Sugar",
                data: chartData.glucoseChart.map((item) => item.number_2_post_glucose ? item.number_2_post_glucose : 0),
                borderColor: '#DE7D24',
                backgroundColor: '#DE7D24',
                yAxisID: 'y1',
            },
            {
                label: "2 Hours Post Breakfast",
                data: chartData.glucoseChart.map((item) => item.number_2_hrs_post_bfast ? item.number_2_hrs_post_bfast : 0),
                borderColor: '#202020',
                backgroundColor: '#202020',
                yAxisID: 'y1',
            },
            {
                label: "Pre Lunch",
                data: chartData.glucoseChart.map((item) => item.lunch ? item.lunch : 0),
                borderColor: '#0461B7',
                backgroundColor: '#0461B7',
                yAxisID: 'y2',
            },
            {
                label: "Post Lunch",
                data: chartData.glucoseChart.map((item) => item.number_2_hrs_post_lunch ? item.number_2_hrs_post_lunch : 0),
                borderColor: 'rgba(98, 129, 91, 0.41)',
                backgroundColor: 'rgba(98, 129, 91, 0.41)',
                yAxisID: 'y3',
            },
            {
                label: "Pre Dinner",
                data: chartData.glucoseChart.map((item) => item.pre_dinner ? item.pre_dinner : 0),
                borderColor: '#AF2591',
                backgroundColor: '#AF2591',
                yAxisID: 'y4',
            },
            {
                label: "2 hours Post Dinner",
                data: chartData.glucoseChart.map((item) => item.number_2_hrs_post_dinner ? item.number_2_hrs_post_dinner : 0),
                borderColor: '#29B6F6',
                backgroundColor: '#29B6F6',
                yAxisID: 'y5',
            },
        ],
    };
    const PopupClose = () => {
        setisExpandCliked(false)
    }

    const getGrowthchart = () => {
        try {
            RestAPIService.getAll(Serviceurls.PD_GROWTH_CHART + `?patient_id=${PatientID}&doc_id=${doctorID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const data = response?.data?.data;
                        setgrowthChart(data);
                        // Auto-select age group chip based on patient age when height/weight is active.
                        // Use raw year value (no rounding) so 5Y 11M → '0-5', not '6-18'.
                        if (filter_data === 'height' || filter_data === 'weight') {
                            const patient = data?.patient || {};
                            let ageYears = 0;
                            if (patient.age) {
                                const parsed = parseInt(String(patient.age).split(',')[0], 10);
                                if (!isNaN(parsed)) ageYears = parsed;
                            }
                            setAgeGroup(ageYears < 6 ? '0-5' : '6-18');
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    useEffect(() => {
        if (growthChart && Object.keys(growthChart).length > 0) {
            setPlotHeightChart(growthChart, filter_data);
        }
    }, [growthChart, filter_data]);

    const getVisitDateForTooltip = (patientIndex, totalPoints, dob, appointmentDate, lastVisitDate, ageInYears, visitDateFromApi) => {
        if (visitDateFromApi != null && visitDateFromApi !== '') {
            try {
                var str = String(visitDateFromApi).trim();
                if (str.indexOf('-') !== -1) {
                    var parts = str.split('-');
                    if (parts.length === 3) {
                        var day = parseInt(parts[0], 10), month = parseInt(parts[1], 10) - 1, year = parseInt(parts[2], 10);
                        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                            var d = new Date(year, month, day);
                            if (!isNaN(d.getTime())) return formatDDMMYYYY(d);
                        }
                    }
                }
                var parsed = new Date(str);
                return isNaN(parsed.getTime()) ? str : formatDDMMYYYY(parsed);
            } catch (e) { return String(visitDateFromApi); }
        }
        if (patientIndex === totalPoints - 1) {
            if (appointmentDate) {
                try {
                    var d = new Date(appointmentDate);
                    return isNaN(d.getTime()) ? appointmentDate : formatDDMMYYYY(d);
                } catch (e) { return appointmentDate; }
            }
            if (lastVisitDate) {
                try {
                    var d = new Date(lastVisitDate);
                    return isNaN(d.getTime()) ? lastVisitDate : formatDDMMYYYY(d);
                } catch (e) { return lastVisitDate; }
            }
            return '-';
        }
        if (!dob || ageInYears == null) return '-';
        try {
            var birth = new Date(dob);
            if (isNaN(birth.getTime())) return '-';
            var monthsToAdd = Math.round(ageInYears * 12);
            var visit = new Date(birth.getFullYear(), birth.getMonth() + monthsToAdd, birth.getDate());
            return formatDDMMYYYY(visit);
        } catch (e) { return '-'; }
    }

    const getParamLabel = (type) => {
        switch (type) {
            case 'height': return 'Height (cm)';
            case 'weight': return 'Weight (kg)';
            case 'bmi': return 'BMI';
            case 'head circumference': return 'Head Circumference (cm)';
            default: return type;
        }
    }

    const formatDDMMYYYY = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        var dd = d < 10 ? '0' + d : String(d);
        var mm = m < 10 ? '0' + m : String(m);
        return dd + '/' + mm + '/' + y;
    }

    const formatAgeAtVisit = (ageInYears) => {
        if (ageInYears == null || ageInYears === '') return '-';
        var y = Math.floor(ageInYears);
        var m = Math.round((ageInYears - y) * 12);
        if (y > 0 && m > 0) return y + ' yr ' + m + ' mo';
        if (y > 0) return y + ' yr';
        return m + ' mo';
    }
    
    const setPlotHeightChart = (response, type, ageGroupParam = null) => {

        let patientGrowth = response.patient_growth || {};
        let patient = response.patient || {};

        let patientData;
        var gender = (response.patient && response.patient.gender) ? response.patient.gender : 'm';
        var refData = getStandardGrowthCurves(gender, type);
        var standardCurves = refData.curves || [];
        var refAges = refData.ages || [];

        if (type === "height") {
            patientData = patientGrowth && patientGrowth.height ? patientGrowth.height : [];
        }
        else if (type === "weight") {
            patientData = patientGrowth && patientGrowth.weight ? patientGrowth.weight : [];
        }
        else if (type === "bmi") {
            patientData = patientGrowth && patientGrowth.bmi ? patientGrowth.bmi : [];
        }
        else if (type === "head circumference") {
            patientData = patientGrowth && patientGrowth.head_circumference ? patientGrowth.head_circumference : [];
        }
        var dataFields = PD_data;

        let age = "";

        if (patient) {
            let dataArr = patient.age ? String(patient.age).split(",") : [];
            let lenArr = dataArr.length;

            if (lenArr > 0) {

                age = parseInt(dataArr[0], 10);
                let m = parseInt(dataArr[1], 10);
                let d = parseInt(dataArr[2], 10);

                if (m > 0 || d > 0) {
                    age = age + 1;
                }
            }
        }

        let patientAge = age;

        // For height/weight: determine which age group to display.
        // Use raw year value (no +1 rounding) so 5Y 11M stays in '0-5', not '6-18'.
        var isHeightOrWeight = type === 'height' || type === 'weight';
        var selectedGroup = null;
        if (isHeightOrWeight) {
            var rawAgeYears = parseInt(((patient?.age) || '').split(',')[0], 10);
            if (isNaN(rawAgeYears)) rawAgeYears = 0;
            selectedGroup = ageGroupParam || (rawAgeYears < 6 ? '0-5' : '6-18');
        }

        var ageArray = refAges;
        var refValueLen = ageArray.length;

        var referenceCurves = standardCurves.length > 0
            ? standardCurves.map(function (item, i) {
                var color = (i === 0 || i === 4) ? '#cc33ff' : (i === 1 || i === 3) ? '#00ccff' : (i === 2) ? '#00ff99' : '#ff0066';
                var points = ageArray.map(function (age, idx) {
                    return { x: age, y: item.value[idx] };
                });
                if (isHeightOrWeight) {
                    points = points.filter(function (pt) {
                        return selectedGroup === '0-5' ? pt.x <= 5 : pt.x > 5;
                    });
                }
                return {
                    label: item.label,
                    data: points,
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    borderColor: color,
                    borderWidth: 1.5,
                    fill: false,
                    lineTension: 0.4,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                };
            })
            : [];

        var stringOne = "Length / height for age";
        var stringTwo = patient && patient.gender === "m" ? " Boys " : " Girls ";
        var stringThree = refValueLen > 61 ? "0-18 years" : (patientAge <= 5 ? "0-5 years" : "5-19 years");
        var stringFour = " (Percentile)";
        dataFields.datasets = referenceCurves;

        var patient_record_count = patientGrowth && patientGrowth.age ? patientGrowth.age.length : 0;
        var patientDetails = state.patientDetails || {};
        var dob = patient?.dob || patientDetails?.dob;
        var appointmentDate = patientDetails?.appointment_date || '';
        var lastVisitDate = patientDetails?.last_visit_date || '';

        var visitDatesFromApi = patientGrowth && patientGrowth.visit_date ? patientGrowth.visit_date : null;
        var patientPointsWithTooltip = [];
        for (var i = 0; i < patient_record_count; i++) {
            const ageVal = patientGrowth.age[i]; // age stored in years
            if (ageVal == null || isNaN(ageVal)) continue;
            var visitDateFromApi = visitDatesFromApi && visitDatesFromApi[i] != null ? visitDatesFromApi[i] : null;
            var visitDate = getVisitDateForTooltip(i, patient_record_count, dob, appointmentDate, lastVisitDate, patientGrowth.age[i], visitDateFromApi);
            var ageAtVisit = formatAgeAtVisit(ageVal);
            var paramLabel = getParamLabel(type);
            if (patientData[i] > 0) {
                patientPointsWithTooltip.push({
                    x: ageVal,
                    y: patientData[i],
                    tooltipInfo: { visitDate, ageAtVisit, value: patientData[i], paramLabel }
                });
            }
        }
        patientPointsWithTooltip.sort(function (a, b) { return a.x - b.x; });

        // Filter patient points by age group for height/weight
        if (isHeightOrWeight) {
            patientPointsWithTooltip = patientPointsWithTooltip.filter(function (p) {
                return selectedGroup === '0-5' ? p.x <= 5 : p.x > 5;
            });
        }

        var patientDataPoints = patientPointsWithTooltip.map(function (p) { return { x: p.x, y: p.y }; });
        var tooltipDataArr = patientPointsWithTooltip.map(function (p) { return p.tooltipInfo; });

        var patient_height_dataset = {
            label: type,
            data: patientDataPoints,
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: '#1a56db',
            fill: false,
            lineTension: 0,
            type: 'line',
            borderWidth: 3,
            pointRadius: 6,
            pointHoverRadius: 8,
            pointBackgroundColor: '#1a56db',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
        };

        dataFields.datasets.push(patient_height_dataset);
        dataFields.labels = [];

        var yMin = Infinity, yMax = -Infinity;
        referenceCurves.forEach(function (curve) {
            (curve.data || []).forEach(function (pt) {
                var v = pt && pt.y != null ? Number(pt.y) : NaN;
                if (!isNaN(v)) { yMin = Math.min(yMin, v); yMax = Math.max(yMax, v); }
            });
        });
        patientDataPoints.forEach(function (pt) {
            var v = pt && pt.y != null ? Number(pt.y) : NaN;
            if (!isNaN(v)) { yMin = Math.min(yMin, v); yMax = Math.max(yMax, v); }
        });
        if (yMin === Infinity) yMin = 0;
        if (yMax === -Infinity) yMax = 100;
        var padding = Math.max((yMax - yMin) * 0.05, 1);
        var chartYMin = Math.max(0, yMin - padding);
        var chartYMax = yMax + padding;

        setPD_data(dataFields)
        setState((prev) => ({
            ...prev,
            commonString: stringOne + stringTwo,
            ageString: stringThree + stringFour,
            growthTooltipData: tooltipDataArr,
            chartYMin,
            chartYMax,
        }));
        if (isHeightOrWeight) {
            setAgeGroup(selectedGroup);
        }
    }

    useEffect(() => {
        if (filter_data && PatientID) {
            getGrowthchart();
        }
    }, [filter_data, PatientID]);
    const renderChip = () => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'}>
                        <Box component={'div'}>
                            {filterItem?.map((item, index) => {
                                return (
                                    <Chip
                                        className={`eMed_chip ${(item.label).toLowerCase() === filter_data ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={item.label}
                                        variant={item.label === filter_data ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            if (item?.value === 'height' || item?.value === 'weight') {
                                                setAgeGroup(null); // reset so getGrowthchart auto-selects
                                            }
                                            setfilter_data(item?.value)
                                            // getGrowthchart()
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                )
                            })}
                        </Box>
                        {(filter_data === 'height' || filter_data === 'weight') && (
                            <Box component={'div'} mt={'0.8vw'}>
                                <Typography fontSize={'0.8vw'} fontWeight={600} mb={'0.3vw'}>Age Group</Typography>
                                {[{ label: '0-5 Years', value: '0-5' }, { label: '6-18 Years', value: '6-18' }].map((ag, idx) => (
                                    <Chip
                                        key={idx}
                                        className={`eMed_chip ${ageGroup === ag.value ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={ag.label}
                                        variant={ageGroup === ag.value ? 'contained' : 'outlined'}
                                        clickable
                                        onClick={() => {
                                            setAgeGroup(ag.value);
                                            setPlotHeightChart(growthChart, filter_data, ag.value);
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderGrowChart = () => {
        let data = PD_data
        let growthTooltipData = state.growthTooltipData || [];
        const is05Chart = filter_data === 'bmi' || filter_data === 'head circumference';
        const isHeightOrWeight = filter_data === 'height' || filter_data === 'weight';
        const xMin = isHeightOrWeight && ageGroup === '6-18' ? 6 : 0;
        const xMax = is05Chart ? 5 : (isHeightOrWeight && ageGroup === '0-5' ? 5 : 18);
        let chartFont = "Open Sans";

        const options1 = {
            animations: false,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true
                },
                title: {
                    display: false
                },
                tooltip: {
                    titleFont: {
                        family: chartFont,
                    },
                    bodyFont: {
                        family: chartFont,
                    },
                    callbacks: {
                        title: (context) => {
                            if (!context || !context.length) return '';
                            var isPatientDataset = data.datasets && context[0].datasetIndex === data.datasets.length - 1;
                            if (isPatientDataset && growthTooltipData[context[0].dataIndex]) {
                                var info = growthTooltipData[context[0].dataIndex];
                                return info.paramLabel + ': ' + info.value;
                            }
                            return context[0].dataset.label || '';
                        },
                        label: (context) => {
                            var isPatientDataset = data.datasets && context.datasetIndex === data.datasets.length - 1;
                            if (!isPatientDataset) {
                                var raw = context.raw;
                                return context.dataset.label + ': ' + (raw && typeof raw === 'object' && 'y' in raw ? raw.y : context.raw);
                            }
                            var raw = context.raw;
                            if (raw == null || (typeof raw === 'object' && raw.y == null)) return null;
                            var tooltipInfo = growthTooltipData[context.dataIndex];
                            if (!tooltipInfo) return context.dataset.label + ': ' + (typeof raw === 'object' ? raw.y : raw);
                            return [
                                'Visit Date: ' + tooltipInfo.visitDate,
                                'Age at Visit: ' + tooltipInfo.ageAtVisit,
                                tooltipInfo.paramLabel + ': ' + tooltipInfo.value,
                            ];
                        },
                    },
                },
            },
            scales: {
                x: {
                    type: 'linear',
                    min: xMin,
                    max: xMax,
                    title: {
                        display: true,
                        text: 'Age (years)',
                        font: { family: chartFont, size: 12 }
                    },
                    grid: {
                        color: 'rgba(0, 0, 0, 0.08)',
                        drawTicks: true,
                    },
                    ticks: {
                        stepSize: 1,
                        font: {
                            weight: 'bold',
                            family: chartFont,
                            size: 12
                        }
                    }
                },
                y: {
                    grid: {
                        color: 'rgba(0, 0, 0, 0.08)',
                    },
                    ticks: {
                        align: 'center',
                        font: {
                            weight: 'bold',
                            family: chartFont
                        },
                    }
                },
            },
            animations: {
                tension: {
                    duration: 1000,
                    easing: 'linear',
                    from: 0.2,
                    to: 0,
                    loop: true
                }
            }
        };
        try {
            return (
                <Box component={'div'}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ width: '2vw' }}>
                            <Typography sx={{ rotate: "270deg" }} >{returnchartText(filter_data)}</Typography>
                        </Box>
                        <Box component={'div'} p={'0.5vw'} sx={{ height: '57vh', width: '57vw' }}>
                            <Line
                                key={PD_data.datasets.length}
                                options={options1}
                                data={data}
                            />
                        </Box>
                    </Box>

                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const returnchartText = (text) => {
        switch (text) {
            case "height": return "Height_(cms)"
            case "weight": return "Weight_(Kgs)"
            case "bmi": return "BMI"
            case "head circumference": return "Head_Circumference_(cms)"
            default: return ""
        }
    }
    const renderMultiLineText = (label, val, stateKey) => {

        return (
            <TextField
                label={label}
                sx={{ marginLeft: "1vw", marginY: "0.5vw", width: "30vw" }}
                multiline={true}
                InputProps={{ readOnly: true }}
                inputProps={{ maxLength: 250 }}
                value={val || ''}
                rows={2} />

        )
    }

    return (
        <Box marginLeft={'.5vw'}>
            <Typography fontSize={'1vw'} fontWeight={'bold'}>Charts</Typography>
            {roleType === 'DB' ?
                <Box >
                    <Grid container spacing={1} >
                        <Grid item xs={6} >
                            <TriggerApiOnView id={`hba1ccharts_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                                <Box id={`hba1ccharts_${id}`} height={'20vw'} columnGap={'1vw'}>
                                    <LineChartView
                                        title={"HBA1C Chart"}
                                        chartLabel={listOfLabels}
                                        chartData={listOfValues}
                                    />
                                </Box>
                            </TriggerApiOnView>
                        </Grid>
                        <Grid item xs={6} >
                            <TriggerApiOnView id={`glugosecharts_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                                <Box id={`glugosecharts_${id}`} height={'20vw'} columnGap={'.5vw'}>
                                    <Paper className='eMed_chart_wrapper' elevation={2} sx={{ height: '20vw' }}>
                                        <Box className="eMed_revenueTbl_titleDiv">
                                            <Typography id="eMed_chart_headTxt">{`Glucose Chart`}</Typography>
                                            {chartData.glucoseChart.length > 0 ? <IconButton size='small' onClick={() => { setisExpandCliked(true); settitle('Glucose Chart') }}>
                                                <img className='emedhub_expand_img' src={ImagePaths.ExpandView.default} alt="Expand" />
                                            </IconButton> : null}
                                        </Box>
                                        <Box className="eMed_Line_chartDiv" sx={{ cursor: "default" }}>
                                            {chartData.glucoseChart.length > 0 ? <Line options={options} data={data} />
                                                : <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', height: '15vw' }}>{'No Records to be Shown'}</Box>}
                                        </Box>
                                    </Paper>
                                </Box>
                            </TriggerApiOnView>
                        </Grid>
                    </Grid>
                </Box> :
                roleType === 'PD' ?
                    <Box marginLeft={'1vw'}>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>Immunization</Typography>
                        <TriggerApiOnView id={`immunization_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                            <Box id={`immunization_${id}`}>
                                <Paper>
                                    <TableContainer>
                                        <Table size='small' aria-label="stictbl">
                                            <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '14vw' }}>Age</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '13vw' }}>Vaccination</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '13vw' }}>Dose</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '13vw' }}>Route</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Due Date</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Given Date</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Brand</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {immunizationData.map((group, groupIndex) => (
                                                    group.data.map((row, rowIndex) => (
                                                        <TableRow key={rowIndex}>
                                                            {rowIndex === 0 && (
                                                                <TableCell rowSpan={group.data.length} sx={{ width: '14vw', borderRight: '1px solid #ddd' }}>{group.age ? group.age : '-'}</TableCell>
                                                            )}
                                                            <TableCell sx={{ width: '13vw', verticalAlign: 'middle' }}>{row?.vaccination?.length > 25 ?
                                                                <Tooltip title={row?.vaccination} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.vaccination).slice(0, 25) + '...'}</Typography></Tooltip> :
                                                                row?.vaccination ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.vaccination}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell sx={{ width: '13vw' }}>{row?.dose?.length > 25 ?
                                                                <Tooltip title={row?.dose} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.dose).slice(0, 25) + '...'}</Typography></Tooltip> :
                                                                row?.dose ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.dose}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell sx={{ width: '13vw' }}>{row?.route?.length > 25 ?
                                                                <Tooltip title={row?.route} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.route).slice(0, 25) + '...'}</Typography></Tooltip> :
                                                                row?.route ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.route}</Typography> : '-'}
                                                            </TableCell>
                                                            <TableCell sx={{ width: '15vw' }}>{row.due_date ? row.due_date : '-'}</TableCell>
                                                            <TableCell sx={{ width: '15vw' }}>{row.given_date ? row.given_date : '-'}</TableCell>
                                                            <TableCell sx={{ width: '10vw' }}>{
                                                                row?.brand_name?.length > 10 ?
                                                                    <Tooltip title={row?.brand_name} placement='top'><Typography component={'div'} fontSize={"0.8rem"}>{(row.brand_name).slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                    row?.brand_name ? row?.brand_name : '-'
                                                            }</TableCell>
                                                        </TableRow>
                                                    ))
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Box>
                        </TriggerApiOnView>
                        {/* {growthChart.length > 0 ? */}
                        <TriggerApiOnView id={`growth_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                            <Box id={`growth_${id}`}>
                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginTop={'.5vw'}>{`Growth Chart`}</Typography>
                                <Box>
                                    <Box>
                                        {renderChip()}
                                        {renderGrowChart()}
                                    </Box>
                                </Box>
                            </Box>
                        </TriggerApiOnView>
                        {/* : null} */}
                    </Box> :
                    roleType === 'OBGYN' ?
                        <Box>
                            <TriggerApiOnView id={`ovulation_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                                <Box id={`ovulation_${id}`}>
                                    <Box>
                                        <Box className="eMed_DocNotes_FreqChips_Wrapp">
                                            {
                                                PrevOvulaData?.length > 0 ? PrevOvulaData.map((item, index) => (
                                                    <Chip
                                                        size='small'
                                                        className={`eMed_chip ${SelectedOvulation?.last_menstrual_period === item?.last_menstrual_period ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                        key={index}
                                                        label={item?.last_menstrual_period}
                                                        variant={SelectedOvulation?.last_menstrual_period === item?.last_menstrual_period ? 'contained' : "outlined"}
                                                        onClick={() => {
                                                            setSelectedOvulation(item);
                                                            setTimeout(() => {
                                                                GetOvulationData(item.id)
                                                            }, 1000);
                                                        }}
                                                    />
                                                )) : null
                                            }
                                        </Box>
                                    </Box>
                                    <Box sx={{ border: '1px solid #888888', borderRadius: '1px', height: 'auto' }}>
                                        <Box sx={{ backgroundColor: '#FAF9F9', height: '2vw', paddingLeft: '1vw' }}>
                                            <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Ovulation Chart`}</Typography>
                                        </Box>
                                        <Box>
                                            <Box display={'flex'} justifyContent={'space-between'} padding={'.5vw'}>
                                                <Box>
                                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>{`Last Menstrual Period`}</Typography>
                                                    <Typography fontSize={'1vw'}>{formatDate(OvulationHeader?.last_menstrual_period)}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>{`Therapy`}</Typography>
                                                    <Typography fontSize={'1vw'}>{OvulationHeader?.therapy}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>{`Procedure`}</Typography>
                                                    <Typography fontSize={'1vw'}>{OvulationHeader?.procedure}</Typography>
                                                </Box>
                                            </Box>
                                            <Box display={'flex'} justifyContent={'space-between'} padding={'.5vw'}>
                                                <Paper>
                                                    <TableContainer>
                                                        <Table size='small' aria-label="stictbl">
                                                            <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Date</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Days</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Right Ovary</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Left Overy</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Uterus</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Endometrium</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Pouch of Douglas</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {OvulationTable?.length > 0 ? OvulationTable?.map((item, index) => (
                                                                    <TableRow>
                                                                        <TableCell sx={{ width: '20vw' }}>{item?.date_of_visit ? formatDate(item?.date_of_visit) : "-"}</TableCell>
                                                                        <TableCell sx={{ width: '20vw' }}>{item?.day || "-"}</TableCell>
                                                                        <TableCell sx={{ width: '20vw' }}>{item?.right_ovary || "-"}</TableCell>
                                                                        <TableCell sx={{ width: '15vw' }}>{item?.left_ovary || "-"}</TableCell>
                                                                        <TableCell sx={{ width: '25vw' }}>{item?.uterus || "-"}</TableCell>
                                                                        <TableCell sx={{ width: '25vw' }}>{item?.endometrium || "-"}</TableCell>
                                                                        <TableCell sx={{ width: '25vw' }}>{item?.pouch_of_douglas || "-"}</TableCell>
                                                                    </TableRow>
                                                                )) :
                                                                    <TableRow>
                                                                        <TableCell colSpan={5} sx={{ width: '20vw' }}>{`No Records to Be Shown`}</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Box>
                                            <Box display={'flex'} justifyContent={'space-between'}>
                                                <Box>
                                                    {renderMultiLineText("Follicular Phase", OvulationHeader?.follicular_phase, "FollicularPhase")}
                                                    {renderMultiLineText("Ovulatory Phase", OvulationHeader?.ovulatory_phase, "OvulatoryPhase")}
                                                </Box>
                                                <Box>
                                                    {renderMultiLineText("Luteal Phase", OvulationHeader?.luteal_phase, "LutealPhase")}
                                                    {renderMultiLineText("Comments", OvulationHeader?.comments, "Comments")}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </TriggerApiOnView>
                            <TriggerApiOnView id={`antenatal_${id}`} onEnterView={(id) => getchartData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                                <Box id={`antenatal_${id}`} marginTop={"1vw"}>
                                    <Box sx={{ border: '1px solid #888888', borderRadius: '1px', height: 'auto' }}>
                                        <Box sx={{ backgroundColor: '#FAF9F9', height: '2vw', paddingLeft: '1vw' }}>
                                            <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Antenatal Chart`}</Typography>
                                        </Box>
                                        <Box>
                                            <AntenatalChart isFrom={'CollabSum'} />
                                        </Box>
                                    </Box>
                                </Box>
                            </TriggerApiOnView>
                        </Box>
                        : <Box sx={{ height: '4vw', border: '1px solid #888888', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{'Charts Not Available'}</Box>}
            {isExpandCliked ?
                <ExpandPopUp
                    hideview={true}
                    title={title}
                    chartView={<Line height={'120vh'} options={options} data={data} />}
                    popUpClose={PopupClose.bind(this)}
                /> : null
            }
        </Box>
    )
}
